var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{class:("icon fab " + (_vm.$store.getters.findIcon(_vm.fileType).icon))}),_vm._v(" "+_vm._s(_vm.filename)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }